import clsx from 'clsx'
import Link from 'next/link'
import { useEffect, useRef } from 'react'

import { Shop } from '@/features/product/choose-pickup-point/types/shop'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { formatShopName } from '@/shared/lib/utils/string/formatShopName'
import { Radio } from '@/shared/ui/radio'

import cl from './ShopsList.module.scss'

interface ShopsListProps {
	shops?: Shop[]
	onSelect?: (shop: Shop) => void
	activeValue?: string
	hideRadio?: boolean
	scrollToShop?: string // Добавляем новый проп
}

export const ShopsList = (props: ShopsListProps) => {
	const { shops = [], onSelect, activeValue = null, hideRadio, scrollToShop } = props
	const shopRefs = useRef<(HTMLLIElement | null)[]>([])

	const handleSelect = (shop: Shop) => {
		onSelect?.(shop)
	}

	// Скроллим к активному магазину
	useEffect(() => {
		if (scrollToShop) {
			const shopIndex = shops.findIndex(shop => shop.STORE_ID === scrollToShop)
			if (shopIndex !== -1 && shopRefs.current[shopIndex]) {
				shopRefs.current[shopIndex]?.scrollIntoView({
					behavior: 'smooth',
					block: 'nearest', // Используем 'nearest', чтобы элемент оказался видимым внутри прокручиваемого контейнера
					inline: 'start'
				})
			}
		}
	}, [scrollToShop, shops])

	return (
		<div className={cl.root} datatype="list">
			<ul className={cl.list}>
				{shops.map((shop, i) => {
					return (
						<li
							key={i}
							className={clsx(cl.shop, { [cl.shop__active]: shop.STORE_ID === activeValue })}
							onClick={() => handleSelect(shop)}
							ref={el => (shopRefs.current[i] = el)} // Добавляем ref
						>
							<div className={cl.shop__info}>
								<h4 dangerouslySetInnerHTML={createMarkup(formatShopName(shop.NAME))} />
								<p className={clsx(cl.shop__metro, cl[`shop__metro__${shop.METRO_LINE}`])}>{shop.METRO}</p>
								<p className={cl.shop__address}>{shop.FULL_ADDRESS}</p>
								<p className={cl.shop__schedule}>{shop.SCHEDULE}</p>
								{/* Убрано по задаче: https://jira.nbcomgroup.ru/browse/DEV-1957 */}
								{/* <Link prefetch={false} href={`tel:${shop.PHONE}`} className={cl.shop__address}>
									{shop.PHONE}
								</Link> */}
								<Link prefetch={false} href={`/shops/${shop.STORE_ID}`} className={cl.shop__button}>
									Подробнее
								</Link>
							</div>
							{!hideRadio && <Radio name="shop" value={shop.NAME} checked={shop.NAME === activeValue} />}
						</li>
					)
				})}
			</ul>
		</div>
	)
}
